class Header {
  constructor() {
    this.init();
  }

  init() {
    this.initAnnouncementBar();
    this.initSearchPanel();
    this.initMegaMenu();
  }

  initAnnouncementBar() {
    const closeButton = document.querySelector('.announcement-bar__close');
    const announcementBar = document.querySelector('.announcement-bar');

    if (!closeButton || !announcementBar) return;

    closeButton.addEventListener('click', () => {
      announcementBar.style.height = `${announcementBar.offsetHeight}px`;
      announcementBar.offsetHeight; // 触发回流，确保动画生效
      announcementBar.style.height = '0';
      announcementBar.style.opacity = '0';
      
      setTimeout(() => {
        announcementBar.style.display = 'none';
      }, 300);

      // 存储状态到localStorage，24小时内不再显示
      localStorage.setItem('announcement_closed', Date.now().toString());
    });

    // 检查是否应该显示通知栏
    const lastClosed = localStorage.getItem('announcement_closed');
    if (lastClosed) {
      const hoursElapsed = (Date.now() - parseInt(lastClosed)) / (1000 * 60 * 60);
      if (hoursElapsed < 24) {
        announcementBar.style.display = 'none';
      }
    }
  }

  initSearchPanel() {
    const searchToggle = document.querySelector('.header__search-toggle');
    const searchPanel = document.querySelector('.header__search-panel');
    
    if (!searchToggle || !searchPanel) return;

    searchToggle.addEventListener('click', () => {
      const isHidden = searchPanel.hasAttribute('hidden');
      if (isHidden) {
        searchPanel.removeAttribute('hidden');
        setTimeout(() => {
          const searchInput = searchPanel.querySelector('.header__search-input');
          searchInput?.focus();
        }, 100);
      } else {
        searchPanel.setAttribute('hidden', '');
      }
    });

    // 点击外部关闭搜索面板
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.header__search-panel') && 
          !event.target.closest('.header__search-toggle')) {
        searchPanel.setAttribute('hidden', '');
      }
    });
  }

  initMegaMenu() {
    // 处理分类切换
    document.querySelectorAll('.mega-menu__category-item').forEach(category => {
      category.addEventListener('mouseenter', () => {
        const categoryId = category.dataset.category;
        const menuContainer = category.closest('.mega-menu');
        
        // 更新类别激活状态
        menuContainer.querySelectorAll('.mega-menu__category-item').forEach(item => {
          item.classList.toggle('is-active', item === category);
        });

        // 更新产品网格显示
        menuContainer.querySelectorAll('.mega-menu__product-grid').forEach(grid => {
          grid.classList.toggle('is-active', grid.dataset.category === categoryId);
        });
      });
    });

    // 处理菜单悬停效果
    const menuItems = document.querySelectorAll('.header__menu-item');
    let timeout = null;

    menuItems.forEach(item => {
      const megaMenu = item.querySelector('.mega-menu');
      if (!megaMenu) return;

      // 鼠标进入菜单项
      item.addEventListener('mouseenter', () => {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        megaMenu.style.display = 'block';
        requestAnimationFrame(() => {
          megaMenu.style.opacity = '1';
          megaMenu.style.transform = 'translateY(0)';
        });
      });

      // 鼠标离开菜单项
      item.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          megaMenu.style.opacity = '0';
          megaMenu.style.transform = 'translateY(10px)';
          setTimeout(() => {
            if (megaMenu.style.opacity === '0') {
              megaMenu.style.display = 'none';
            }
          }, 300);
        }, 150);
      });

      // 鼠标进入mega menu时清除关闭计时器
      megaMenu.addEventListener('mouseenter', () => {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
      });

      // 鼠标离开mega menu时延迟关闭
      megaMenu.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          megaMenu.style.opacity = '0';
          megaMenu.style.transform = 'translateY(10px)';
          setTimeout(() => {
            if (megaMenu.style.opacity === '0') {
              megaMenu.style.display = 'none';
            }
          }, 300);
        }, 300);
      });
    });
  }
}

// 当DOM加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  new Header();
});

document.addEventListener('DOMContentLoaded', function() {
  const menuToggle = document.querySelector('.header__menu-toggle');
  const nav = document.querySelector('.header__nav');
  
  if (menuToggle && nav) {
    menuToggle.addEventListener('click', function() {
      nav.classList.toggle('is-active');
      document.body.style.overflow = nav.classList.contains('is-active') ? 'hidden' : '';
    });

    // 点击遮罩层关闭菜单
    nav.addEventListener('click', function(e) {
      if (e.target === nav) {
        nav.classList.remove('is-active');
        document.body.style.overflow = '';
      }
    });
  }
});